<template lang="html">
  <div class="">
    <v-window v-model="window">
      <v-window-item key="0">
        <si-container>
          <v-flex xs12>
            <v-card>
              <v-data-table
                :headers="tableHeaders"
                :items="suggestionsSorted"
                sort-by="pinned"
                sort-desc
                :items-per-page="15"
                class="cursor-pointer"
                @click:row=" item => $router.push(`suggestions/${item.id}`)"
              >
                <template #item.rating="{ item }">
                  <v-layout align-center>
                    <v-icon
                      left
                      color="yellow darken-2"
                    >
                      star
                    </v-icon> {{ item.rating }}
                  </v-layout>
                </template>
                <template #item.pinned="{ item }">
                  <v-checkbox
                    v-model="item.pinned"
                    class="ma-0"
                    hide-details
                    @click.stop="pinSuggestion(item.id, item.pinned)"
                  />
                </template>
                <template #item.timestamp="{ item }">
                  {{ _formatDateTime(Number(item.timestamp)) }}
                </template>
                <template #item.for="{ item }">
                  <v-icon v-if="item.for === 'calculator'">
                    assessment
                  </v-icon>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </si-container>
      </v-window-item>

      <v-window-item key="1">
        <si-container back="/suggestions">
          <v-flex xs12>
            <v-card>
              <v-container pa-4>
                <v-layout wrap>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      Pinned
                    </div>
                    <div>
                      <v-checkbox
                        v-model="suggestionItem.pinned"
                        class="ma-0"
                        label="Pinned"
                        hide-details
                        @click.stop="pinSuggestion(suggestionItem.id, suggestionItem.pinned)"
                      />
                    </div>
                  </v-flex>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      Date
                    </div>
                    <div>{{ _formatDateTime(Number(suggestionItem.timestamp)) }}</div>
                  </v-flex>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      Caption
                    </div>
                    <v-layout
                      align-center
                      ma-0
                    >
                      {{ suggestionItem.caption }}
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      Description
                    </div>
                    <v-layout
                      align-center
                      ma-0
                    >
                      {{ suggestionItem.description }}
                    </v-layout>
                  </v-flex>
                  <v-flex xs12>
                    <div class="caption grey--text">
                      Email (if supplied)
                    </div>
                    <div>
                      <a :href="`mailto:${suggestionItem.email}`">{{ suggestionItem.email }}</a> <i
                        v-if="!suggestionItem.email"
                        class=" grey--text text--lighten-2"
                      >no email</i>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </si-container>
      </v-window-item>
    </v-window>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import analytics from '@/mixins/analytics'
import seen from '@/mixins/seen'

export default {
  mixins: [ helpers, binder, analytics, seen ],
  props: {

  },
  data () {
    return {
      suggestions: {},
      calculatorStats: {},
      tableHeaders: [
        // { text: 'Rating', value: 'rating', width: 80 },
        { text: 'Pin', value: 'pinned', width: 50 },
        { text: 'Date', value: 'timestamp', width: 160 },
        { text: 'Caption', value: 'caption' }
      ]
    }
  },
  computed: {
    ...mapGetters(['_calculators']),
    window () {
      return this.$route.params.sub ? 1 : 0
    },
    suggestionsSorted () {
      return this._sortObject(this.suggestions, 'timestamp')
    },
    suggestionItem () {
      let id = this.$route.params.sub
      return this.suggestions[id] || {}
    }
  },
  watch: {

  },
  beforeMount () {
    // this.$bindxxx(rtdb.ref(`/feedback/suggestions`), 'suggestions', true)
    this.$bindRtdb('suggestions', `/feedback/suggestions`, { loader: true })
    this.$store.commit('set_appBarTitle', {title: 'Tool Suggestions', icon: 'loupe'})
    this._seenUpdate('suggestions')

  },
  methods: {
    pinSuggestion (id, state) {
      rtdb.ref(`feedback/suggestions/${id}/pinned`).set(!state)
    }
  }
}
</script>

<style lang="css" scoped>

</style>
